import * as Contract from '@tableau/api-internal-contract-js';

/**
 * Custom internal error class that wraps an internal error code.  Will get
 * converted to an external error before being propogated to developer.
 */
export class InternalTableauError extends Error implements Contract.InternalTableauError {
  public constructor(private _errorCode: Contract.ErrorCodes, message: string) {
    super(message);

    /*tslint:disable-next-line */
    // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    // Error inheritance does not work propertly when compiling to ES5, this is a workaround to force
    // the proto chain to be built correctly.  See the github link above for details.
    Object.setPrototypeOf(this, InternalTableauError.prototype);
  }

  public get errorCode(): Contract.ErrorCodes {
    return this._errorCode;
  }
}
